import { FC, useState } from 'react';
import { formatNumberAsCurrency, parseCurrency } from 'helpers/utils';
import { AllocationGroup } from '../types';

type Props = {
  group: AllocationGroup;
  onGroupChange: (patch: Partial<AllocationGroup>) => void;
  isLastGroup: boolean;
};

export const WaterfallInputControl: FC<Props> = ({ group, onGroupChange, isLastGroup }) => {
  const [rawValue, setRawValue] = useState(
    group.donation_limit_cents != null ? String(group.donation_limit_cents / 100) : ''
  );
  const [isEditing, setIsEditing] = useState(false);

  const displayValue =
    !isEditing && rawValue !== ''
      ? formatNumberAsCurrency(parseCurrency(rawValue)).replace('$', '')
      : rawValue;

  if (isLastGroup) {
    return (
      <div className="allocation-input-wrapper allocation-input-wrapper--no-limit">
        <span className="oath-utility gray">No limit</span>
      </div>
    );
  }

  return (
    <div className="allocation-input-wrapper">
      <span className="allocation-input-symbol oath-utility">$</span>
      <input
        type="text"
        inputMode="decimal"
        className="allocation-input"
        value={displayValue}
        onFocus={() => setIsEditing(true)}
        onChange={e => {
          const digits = e.target.value.replace(/[^0-9.]/g, '');
          setRawValue(digits);
          onGroupChange({
            donation_limit_cents: digits === '' ? null : Math.round(parseCurrency(digits) * 100),
          });
        }}
        onBlur={() => {
          setIsEditing(false);
          if (rawValue !== '') setRawValue(String(parseCurrency(rawValue)));
        }}
      />
    </div>
  );
};
